import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';

export default function Header({ v }) {
  return (
    <div style={css(v.headerStyle)}>
      {' '}
      <div style={{ "gridColumn": "1", "display": "flex", "alignItems": "center", "gap": "12px", "minWidth": "0", "overflow": "visible", "pointerEvents": "none" }}>
        {v.showVersionBadge ? (<>
          <button onClick={v.requestFeature} title="Naar de ideeënbus" className="gp-btn gp-klein" style={css(v.versionBadgeStyle)}>
            <Interp v={v.appVersion} />
          </button>
        </>) : null}
        {v.showLogo ? (
        <div className="gp-logo" onClick={v.openWelcome} title="Wat is er nieuw?" style={css(v.logoStyle)}>
          <span style={{ "animationDuration": "0.34s", "animationDelay": "0s" }}>
            K
          </span>
          <span style={{ "animationDuration": "0.42s", "animationDelay": "0.07s" }}>
            r
          </span>
          <span style={{ "animationDuration": "0.4s", "animationDelay": "0.09s" }}>
            a
          </span>
          <span style={{ "animationDuration": "0.36s", "animationDelay": "0.12s" }}>
            b
          </span>
          <span style={{ "animationDuration": "0.48s", "animationDelay": "0.04s" }}>
            b
          </span>
          <span style={{ "animationDuration": "0.31s", "animationDelay": "0.16s" }}>
            e
          </span>
          <span style={{ "animationDuration": "0.43s", "animationDelay": "0.06s" }}>
            l
          </span>
          <span style={{ "animationDuration": "0.37s", "animationDelay": "0.13s" }}>
            p
          </span>
          <span style={{ "animationDuration": "0.33s", "animationDelay": "0.01s" }}>
            a
          </span>
          <span style={{ "animationDuration": "0.45s", "animationDelay": "0.1s" }}>
            a
          </span>
          <span style={{ "animationDuration": "0.39s", "animationDelay": "0.08s" }}>
            l
          </span>
          <span style={{ "animationDuration": "0.35s", "animationDelay": "0.15s", "whiteSpace": "pre" }}>
            {' '}
          </span>
          <span style={{ "animationDuration": "0.41s", "animationDelay": "0.05s" }}>
            X
          </span>
          <span style={{ "animationDuration": "0.47s", "animationDelay": "0.11s" }}>
            P
          </span>
        </div>
        ) : null}
      </div>
      {' '}
      {v.showTabs ? (<>
        {' '}
        <div style={{ "position": "absolute", "left": "50%", "top": "50%", "transform": "translate(-50%,-50%)", "zIndex": "2", "display": "flex", "background": "#fff", "border": "3px solid var(--ink)", "borderRadius": "16px", "padding": "4px", "boxShadow": "3px 3px 0 var(--ink)" }}>
          <div style={css(v.tabSliderStyle)} />
          <button onClick={v.goStudio} className="gp-tab" style={css(v.tabStyle?.studio)}>
            Tekenen
          </button>
          <button onClick={v.goGallery} className="gp-tab" style={css(v.tabStyle?.gallery)}>
            De paal
          </button>
        </div>
        {' '}
      </>) : null}
      {' '}
      {/* Rechtsboven, en dat blijft zo ook zonder balk eronder: `pointerEvents` weer
          aan, want de kop zelf laat klikken doorlopen naar de paal. */}
      <div style={{ "gridColumn": "3", "position": "relative", "zIndex": "3", "display": "flex", "justifyContent": "flex-end", "alignItems": "center", "gap": "6px", "flexWrap": "nowrap", "pointerEvents": "auto" }}>
        {v.hasPoll ? (<>
          <button onClick={v.openPoll} className="gp-btn" title="Er is een poll!" style={css(v.pollBtnStyle)}>
            {' '}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 20V10" />
              <path d="M12 20V4" />
              <path d="M18 20v-6" />
            </svg>
            {' '}
            {v.showPollDot ? (<>
              {' '}
              <span style={{ "position": "absolute", "top": "-6px", "right": "-6px", "width": "15px", "height": "15px", "borderRadius": "50%", "background": "var(--roze)", "border": "3px solid var(--ink)" }} />
              {' '}
            </>) : null}
            {' '}
          </button>
        </>) : null}
        {v.showOnlineBar ? (<>
          {/* Wie er nu is: één knop met de koppen erin en het aantal erachter. Klik
              erop en je krijgt de lijst met iedereen. De koppen zijn hier plaatjes en
              geen knopjes meer; ze overlappen elkaar, dus van de meeste was maar een
              streepje aan te klikken. */}
          <button onClick={v.openIedereen} className="gp-btn" title={v.onlineTitle} aria-label={v.onlineTitle} style={css(v.onlineBarStyle)}>
            {v.showOnlineFaces ? (<>
              <span style={{ "display": "flex", "alignItems": "center", "flex": "0 0 auto" }}>
                {toList(v.onlineFaces).map((f, $index) => (
                  <React.Fragment key={$index}>
                    <img alt="" src={f?.avatarUrl} title={f?.name} style={css(f?.style)} />
                  </React.Fragment>
                ))}
                {v.showOnlineCount ? (<>
                  <span style={css(v.onlineRestStyle)}>
                    <Interp v={v.onlineCountLabel} />
                  </span>
                </>) : null}
              </span>
            </>) : null}
            {/* Achter de koppen, niet ervoor: eerst zie je wie er zijn, dan hoeveel
                het er nu zijn. */}
            <span style={css(v.onlineChipStyle)}>
              <span style={css(v.onlineChipDotStyle)} />
              <span style={css(v.onlineChipCountStyle)}>
                <Interp v={v.onlineChipCount} />
              </span>
            </span>
          </button>
        </>) : null}
        {v.showAccountBtn ? (<>
          <button onClick={v.openAccount} className="gp-btn" title={v.connTitle} style={{ "position": "relative", "height": "46px", "borderRadius": "16px", "padding": "3px 14px 3px 3px", "gap": "8px" }}>
            {' '}
            {v.hasAvatar ? (<>
              {' '}
              <img alt="" src={v.myAvatarUrl} style={{ "width": "28px", "height": "28px", "imageRendering": "pixelated", "border": "3px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
              {' '}
            </>) : null}
            {' '}
            {v.noAvatar ? (<>
              {' '}
              <span style={{ "width": "28px", "height": "28px", "border": "2px dashed var(--ink)", "borderRadius": "8px", "display": "flex", "alignItems": "center", "justifyContent": "center", "color": "var(--tekst-3)", "fontSize": "15px", "fontWeight": "700", "flex": "0 0 auto" }}>
                ?
              </span>
              {' '}
            </>) : null}
            {' '}
            {v.showNameLabel ? (<>
              <Interp v={v.myNameLabel} />
            </>) : null}
            {' '}
            <span style={css(v.connDotStyle)} />
            {' '}
          </button>
        </>) : null}
      </div>
      {' '}
    </div>
  );
}
